import { render, staticRenderFns } from "./CreateMerchantBusinessModal.vue?vue&type=template&id=36e0828d&scoped=true&"
import script from "./CreateMerchantBusinessModal.vue?vue&type=script&lang=js&"
export * from "./CreateMerchantBusinessModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateMerchantBusinessModal.vue?vue&type=style&index=0&id=36e0828d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e0828d",
  null
  
)

export default component.exports